/* eslint-disable */

/**
 * A mapping between the CSS class that enforces brand/tenant-specific styles in an authenticated session
 * and the tenant ID.
 */
export enum Brand {
  // wir = 1,
  // sgkb = 1,
  // bcn = 1,
  // ukb = 1,
  addProtect = 0,
  // ficohsa = 0,
  // bankinter = 0,
  // 'hsbc-uk' = 0,
  // postfinance = 1,
  glkb = 2,
}